import { UPDATE_SCRIBE_FAILED, UPDATE_SCRIBE_SUCCESS } from '../actionCreators/scribeActions';
import { RESET_STATE } from '../actionCreators/generalActions';
const initialState = {
  isSaving: false,
  autoSaveError: null,
  autoSaveStatus: 'Idle'
};

export default function autoSaveReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_SCRIBE_FAILED: {
      return {
        ...state,
        isSaving: false,
        autoSaveError: action.error,
        autoSaveStatus: 'Error'
      };
    }

    case UPDATE_SCRIBE_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        autoSaveError: null,
        autoSaveStatus: 'Idle'
      };
    }

    case RESET_STATE: {
      return {
        ...initialState
      };
    }

    default:
      return state;
  }
}
